import { render, staticRenderFns } from "./CommentAnchor.vue?vue&type=template&id=2f9e9c7a&scoped=true&"
import script from "./CommentAnchor.vue?vue&type=script&lang=js&"
export * from "./CommentAnchor.vue?vue&type=script&lang=js&"
import style0 from "./CommentAnchor.vue?vue&type=style&index=0&id=2f9e9c7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9e9c7a",
  null
  
)

export default component.exports